import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import {
  MatCardModule,
} from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { CnpjPipe } from '../../../shared/pipes/cpnj.pipes'
import { ClientService } from '../../../core/services/customer/client/client.service'

@Component({
  selector: 'modal-delete-client',
  imports: [
    MatProgressBar,
    MatCardModule,
    MatIcon,
    MatButton,
    MatProgressSpinner,
    CnpjPipe,
  ],
  templateUrl: './modal-delete-client.component.html',
  styleUrl: './modal-delete-client.component.scss',
  standalone: true,
  providers: [LegalEntityClientService],
})
export class ModalDeleteClientComponent implements OnInit {
  constructor(
    private clienteService: ClientService,
    // private legalEntityClientService: LegalEntityClientService,
    private dialogRef: MatDialogRef<ModalDeleteClientComponent>,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    this.typeClient = data.typeClient
  }
  @Output() responseDelete = new EventEmitter()

  loading = false

  item: any = {}
  typeClient: 'client' | 'subClient' | '' = ''

  ngOnInit() {}

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item.id,
    }
  }

  deleteItem() {
    this.loading = true
    this.clienteService.deleteClient(this.item.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.responseDelete.emit({ delete: true })
        this.close()
      },
      error: (err: PagedContactTypeResponse) => {
        this.snackbar.errorRequest(err)
        this.responseDelete.emit({ delete: false })
        this.close()
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
